<div class="container custom-zero-margin">
  <div class="row banner-section" *ngIf="categoryTypes">
    <div class="col-md-3 img-placeholder" >
      <img
        class="category-img img-thumb"
        *ngIf="categoryTypes.image?.url"
        src="{{ apiurl + categoryTypes.image?.url }}"
      />

      <cx-media
        class="category-missing-img"
        *ngIf="!categoryTypes.image?.url"
        [container]="apiurl + categoryTypes.image?.url"
      >
      </cx-media>
    </div>
    <div class="col-md-9 text-section">
      <h5 class="text-section-header">{{ categoryTypes.name }}</h5>
      <div
        class="custom-zero-margin-bottom text-section-desc"
        [innerHTML]="categoryTypes.description"
      ></div>
    </div>
  </div>
</div>
